import api from './api'

export const labService = {
  // Get all labs
  getAll: async () => {
    const response = await api.get('/labs')
    return response.data.labs || []
  },

  // Get single lab
  getById: async (id) => {
    const response = await api.get(`/labs/${id}`)
    return response.data.lab
  },

  // Get or create draft submission
  getDraftSubmission: async (id) => {
    const response = await api.get(`/labs/${id}/submission/draft`)
    return response.data
  },

  // Get labs by module
  getByModule: async (moduleId) => {
    const response = await api.get(`/labs?module_id=${moduleId}`)
    return response.data
  },

  // Submit lab
  submit: async (id, submissionData) => {
    const response = await api.post(`/labs/${id}/submit`, submissionData)
    return response.data
  },

  // Update progress
  updateProgress: async (id, progressData) => {
    const response = await api.post(`/labs/${id}/progress`, progressData)
    return response.data
  },
}
